import React from 'react';
import { useCurrentDebrief } from 'ff/debrief/hooks';
import Segments from 'ff/debrief/components/segments/Segments';
import InfoSidebar from 'ff/debrief/components/debriefSidebar/InfoSidebar';

const DebriefSidebar = () => {
    const { hasDebrief, isLoading } = useCurrentDebrief();

    if (isLoading) return null;

    if (hasDebrief) {
        return <Segments />;
    } else {
        return <InfoSidebar />;
    }
};

export default DebriefSidebar;
